import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {IonCol, IonRow} from "@ionic/react";
import Modal from "@components/modal/modal.component";
import {StyledModalContent} from "@components/modal/modal.style";
import {StyledTextarea} from "@components/form/input/textarea.style";
import {StyledIonLabel} from "@components/form/input/label.style";
import {StyledButton, StyledWiteButton} from "@components/button/button.style";
import {StyledFooter} from "@components/pane/pane.style";

type ProposalRejectModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (reason: string, replacement: string | null) => void;
};

const ProposalRejectModal: React.FC<ProposalRejectModalProps> = ({isOpen, onClose, onConfirm}: ProposalRejectModalProps) => {
    const {t} = useTranslation();

    const [reason, setReason] = useState<string>('');
    const [replacement, setReplacement] = useState<string>('');

    useEffect(() => {
        if (isOpen) {
            setReason('');
            setReplacement('');
        }
    }, [isOpen]);

    const handleConfirm = () => {
        onConfirm(reason.trim(), replacement.trim() || null);
    };

    return (
        <Modal initialBreakpoint={0.75} breakpoints={[0, 0.75]} isOpen={isOpen} onDidDismiss={() => onClose()}>
            <StyledModalContent className="scrollable">
                <h1 className="title">{t('availability.proposal.reject.title')}</h1>
                <IonRow>
                    <IonCol size="12">
                        <StyledIonLabel className="ion-text-wrap">
                            {t('availability.proposal.reject.reason')} ({t('availability.proposal.reject.optional')})
                        </StyledIonLabel>
                    </IonCol>
                    <IonCol size="12">
                        <StyledTextarea
                            className="full-width small resize-none"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder={t('availability.proposal.reject.reasonPlaceholder')}
                        />
                    </IonCol>
                    <IonCol size="12">
                        <StyledIonLabel className="ion-text-wrap">
                            {t('availability.proposal.reject.replacement')} ({t('availability.proposal.reject.optional')})
                        </StyledIonLabel>
                    </IonCol>
                    <IonCol size="12">
                        <StyledTextarea
                            className="full-width small resize-none"
                            value={replacement}
                            onChange={(e) => setReplacement(e.target.value)}
                            placeholder={t('availability.proposal.reject.replacementPlaceholder')}
                        />
                    </IonCol>
                </IonRow>
                <StyledFooter className="modal footer no-shadow">
                    <div style={{width: '100%'}}>
                        <StyledButton onClick={handleConfirm}>
                            {t('availability.proposal.reject.confirm')}
                        </StyledButton>
                        <StyledWiteButton onClick={() => onClose()}>
                            {t('common.alertCancel')}
                        </StyledWiteButton>
                    </div>
                </StyledFooter>
            </StyledModalContent>
        </Modal>
    );
};

export default ProposalRejectModal;
